import questionController from '../../../controllers/questionController/controller';
import Swal from 'sweetalert2';
import { EventBus } from '@/eventBus';
export default{
    name: 'SimpleTable',
    data() {
        return{
            company: '',
            questionList:[],
            currentPage: 1,
            pageSize: 10,
            totalQuestion: 0,
            totalPages: 0,
            searchQuery: '',
            sizes: [1, 5, 10, 20],
            question:{
                id: '',
                question: '',
                language: '',
                created_by: '',
                created_by_name: '',
                created_on: '',
                status: ''
            },
            question_detail: [],
            q_detail: '',
            selectedQuestion: {
                updated_by: '',
                updated_by_name: '',
            },
            selectedAnswer:{
                answer_id: '',
                status: '',
                created_by: '',
                created_by_name : '',
                created_on: ''
            },
            answerList: []
        }
    },
    computed:{
        filteredQuestion(){
            return this.questionList.filter((question) => {
                return question.question.toLowerCase().includes(this.searchQuery.toLowerCase());
            })
        },
        pages(){
            return Math.ceil(this.totalQuestion / this.pageSize);
        },
        displayedPages() {
            const range = 1;
            let start = Math.max(this.currentPage - range, 1);
            let end = Math.min(this.currentPage + range, this.pages);
      
            // Jika kurang dari 3 halaman, sesuaikan
            if (end - start < 2) {
              if (start === 1) {
                end = Math.min(3, this.pages);
              } else if (end === this.pages) {
                start = Math.max(this.pages - 2, 1);
              }
            }
      
            const pages = [];
            for (let i = start; i <= end; i++) {
              pages.push(i);
            }
            return pages;
        },
        showStartEllipsis() {
            return this.displayedPages[0] > 1;
        },
        showEndEllipsis() {
            return this.displayedPages[this.displayedPages.length - 1] < this.pages;
        },
    },
    methods:{
        user(){
            const user = localStorage.getItem('user');
            const id = JSON.parse(user).mst_employee_id;
            this.question.created_by = id;
            this.selectedQuestion.updated_by = id;
            this.selectedAnswer.created_by = id;
            const name = JSON.parse(user).mst_employee_name;
            this.selectedQuestion.updated_by_name = name;
            this.question.created_by_name = name;
            this.selectedAnswer.created_by_name = name;
        },
        showModal(type, id) {
            this.user();
            const question = this.questionList.find(question => question.id === id);
            if (question) {
                this.question = question;
                
                const modalId = {
                    edit: 'editQuestion',
                    answer_detail: 'answerDetail',
                    default: 'detailQuestion'
                }[type] || 'detailQuestion';
                const modal = document.getElementById(modalId);
                if (modalId === 'answerDetail') {
                    this.getAnswerDetail(id);
                    this.getAnswer();
                }
                modal.style.display = 'block';
                requestAnimationFrame(() => {
                modal.classList.add('show');
                });
                
                document.body.classList.add('modal-open');
                
                const backdrop = document.createElement('div');
                backdrop.classList.add('modal-backdrop', 'fade');
                document.body.appendChild(backdrop);
                
                requestAnimationFrame(() => {
                backdrop.classList.add('show');
                });
            }
        },
        closeModal() {
          const modalIds = ['tambahQuestion', 'editQuestion', 'detailQuestion', 'answerDetail', 'editQuestionDetail'];
          modalIds.forEach(id => {
            const modal = document.getElementById(id);
            if (modal && modal.classList.contains('show')) {
              modal.classList.remove('show');
              setTimeout(() => {
                modal.style.display = 'none';
              }, 300);
            }
          });
        
          // Hapus backdrop
          const backdrops = document.querySelectorAll('.modal-backdrop');
          backdrops.forEach(backdrop => {
            backdrop.classList.remove('show');
            setTimeout(() => {
              if (backdrop.parentNode) {
                backdrop.parentNode.removeChild(backdrop);
              }
            }, 300);
          });
        
          // Hapus kelas atau atribut yang mengunci scroll pada body
          const body = document.body;
          body.classList.remove('modal-open');
          body.style.overflow = ''; // Menghapus properti overflow jika ada
          this.getQuestion();
          this.resetForm();
          this.user();
        },    
        resetForm() {
            this.question.question = '';
            this.question.language = '';
            this.question.status = '';
        },
        reset(){
            this.selectedAnswer = {
                answer_id: '',
                status: '',
                created_by: '',
                created_by_name : '',
                created_on: ''  
            }
        },
        changePage(page) {
            if (page > 0 && page <= this.pages) {
                this.currentPage = page;
                this.getQuestion();
            }
        },
        async getQuestionDetail(id){
            try{
                const response = await questionController.getQuestionDetail(id);
                this.question_detail = response.data;
            } catch (error){
                console.error('Error fetching question detail:', error);
            }
        },
        async getQuestion(){
            try {
                const company = this.company;
                const query = this.searchQuery.trim() === '' ? null : this.searchQuery;
                const response = await questionController.getQuestion(query, this.currentPage, this.pageSize, company);
                this.questionList = response.data;
                this.totalAllQuestion();
            } catch (error) {
                console.error('Error fetching questions:', error);
            }
        },
        async getAnswer(){
            const id = this.question.id;
            try {
                const response = await questionController.getAnswer(id);
                this.answerList = response.data.data;
            } catch (error) {
                console.error('Error fetching answers:', error);
            }
        },
        async getAnswerDetail(id){
            try {
                const response = await questionController.getAnswerDetail(id);
                this.q_detail = response.data.data;
            } catch (error) {
                console.error('Error fetching question detail:', error);
            }
        },
        async totalAllQuestion() {
            try {
                const company = this.company;
                const query = this.searchQuery.trim() === '' ? null : this.searchQuery;
                const response = await questionController.totalAllQuestion(query, company);
                this.totalQuestion = response.data;
            } catch (error) {
                console.error('Error fetching questions:', error);
            }
        },
        async addQuestion() {
            try {
                const question = this.question.question;
                const language = this.question.language;
                const company = this.company;
                const created_by = this.question.created_by;
                const created_by_name = this.question.created_by_name;
                const is_active = this.question.status;
                if(!question || !language || !created_by || !created_by_name || !is_active){
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Semua field harus diisi!',
                    })
                    return;
                }
                const now = new Date();
                const created_on = now.toISOString().slice(0, 19).replace('T', ' ');
                const add = {
                    question: question,
                    language: language,
                    id_company: company,
                    created_by: created_by,
                    created_by_name: created_by_name,
                    created_on: created_on,
                    is_active: is_active
                }
                await questionController.addQuestion(add);
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Question added successfully!',
                    timer: 1500
                })
                this.closeModal();
                this.resetForm();
                this.getQuestion();
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Something went wrong!' + error,
                    timer: 1500
                })
            }
        },
        async addAnswer(){
            try {
                const question_id = this.question.id;
                const answer_id = this.selectedAnswer.answer_id;
                const is_active = this.selectedAnswer.status;
                const created_by = this.selectedAnswer.created_by;
                const created_by_name = this.selectedAnswer.created_by_name;
                const newDate = new Date();
                const created_on = newDate.toISOString().slice(0, 19).replace('T', ' ');
                if (!question_id || !answer_id || !is_active || !created_by || !created_by_name) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Semua field harus diisi!',
                        timer: 1500
                    })
                    return;
                }
                const add = {
                    question_id: question_id,
                    answer_id: answer_id,
                    is_active: is_active,
                    created_by: created_by,
                    created_by_name: created_by_name,
                    created_on: created_on
                }
                await questionController.addAnswer(add);
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Answer berhasil ditambahkan',
                    timer: 1500
                })
                this.getAnswer();
                this.reset();
                this.getAnswerDetail(question_id);
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Gagal menambahkan data: ' + error.message,
                    timer: 1500
                })
            }
        },
        async updateQuestion() {
            try {
                const id = this.question.id;
                const question = this.question.question;
                const language = this.question.language;
                const is_active = this.question.status;
                const updated_by = this.selectedQuestion.updated_by;
                const updated_by_name = this.selectedQuestion.updated_by_name;
                if (!id || !question || !language || !updated_by || !updated_by_name | !is_active) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Semua field harus diisi!',
                        timer: 1500
                    })
                    return;
                }
                const now = new Date();
                const updated_on = now.toISOString().slice(0, 19).replace('T', ' ');
                const update = {
                    id: id,
                    question: question,
                    language: language,
                    is_active: is_active,
                    updated_by: updated_by,
                    updated_by_name: updated_by_name,
                    updated_on: updated_on
                }
                const request = await questionController.updateQuestion(update);
                if (request.status === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Question berhasil diperbaharui',
                        timer: 1500
                    })
                    this.closeModal();
                    this.getQuestion();
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Gagal memperbaharui data',
                        timer: 1500
                    })
                }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Gagal memperbaharui data: ' + error.message,
                    timer: 1500
                })
            }
        },
        async deleteQuestion(id) {
            const confirmed = window.confirm('Are you sure you want to delete this question?')
            if (confirmed) {
                try {
                    await questionController.deleteQuestion(id);
                    await questionController.deleteAnswerbyQuestion(id);
                    alert('Question berhasil dihapus');
                    this.getQuestion();
                } catch (error) {
                    alert('Gagal menghapus data: ' + error.message);
                }
            }
        },
        async deleteDetail(id, question_id){
            const confirmed = await Swal.fire({
                title: 'Are you sure?',
                text: 'You won\'t be able to revert this!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    return true;
                }
                return false;
            });
            if (confirmed) {
                try {
                    await questionController.deleteDetail(id);
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Answer berhasil dihapus',
                        timer: 1500
                    })
                    this.getAnswerDetail(question_id);
                    this.getAnswer();
                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Terjadi kesalahan',
                        timer: 1500
                    })
                }
            }
        },
        onCompanyChange(newCompany) {
            this.company = newCompany;
            console.log("Company updated in HelloWorld.vue:", this.company);
        }
    },
    mounted(){
        this.user();
        this.company = localStorage.getItem('company');
        EventBus.$on("companyChanged", this.onCompanyChange);
    },
    watch:{
        searchQuery: {
            handler: 'getQuestion'
        },
        company: {
            handler: 'getQuestion'
        }
    },
}